module.exports = __webpack_public_path__ + "media/packs/static/fonts/icon/font-853eef823c50d0047b8e549688426281.svg";